/*! @azure/msal-common v14.13.1 2024-07-16 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.13.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
